export const formatMoney = (value: number) =>
  value
    .toLocaleString("es-CO", {
      currency: "COP",
      style: "currency",
      minimumFractionDigits: 0
    })
    .replace(/\s/g, "");